import React from 'react';
import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import Expenses from 'components/Credit24/LoanApplication/ExpensesAU';
import { incomeFrequency, auResidence } from 'consts';
import {
  useExpensesCalculation,
} from './hooks/useExpensesCalculation';

const ExpensesAUContainer = () => {
  const selector = formValueSelector('loan');

  const residentialStatus = useSelector((state) => selector(state, 'residentialStatus'));
  const essentialExpenses = useSelector((state) => selector(state, 'essentialExpenses'));
  const essentialExpensesFrequency = useSelector((state) => selector(state, 'essentialExpensesFrequency'));
  const nonEssentialExpenses = useSelector((state) => selector(state, 'nonEssentialExpenses'));
  const nonEssentialExpensesFrequency = useSelector((state) => selector(state, 'nonEssentialExpensesFrequency'));
  const totalLivingExpenses = useSelector((state) => selector(state, 'totalLivingExpenses'));
  const willForgoNonEssentials = useSelector((state) => selector(state, 'willForgoNonEssentials'));

  useExpensesCalculation({
    residentialStatus,
    essentialExpenses,
    essentialExpensesFrequency,
    nonEssentialExpenses,
    nonEssentialExpensesFrequency,
    totalLivingExpenses,
    willForgoNonEssentials,
  });

  return (
    <Expenses
      incomeFrequencies={incomeFrequency}
      residenceTypes={auResidence}
      residentialStatus={residentialStatus}
      essentialExpenses={essentialExpenses}
      essentialExpensesFrequency={essentialExpensesFrequency}
      nonEssentialExpenses={nonEssentialExpenses}
      nonEssentialExpensesFrequency={nonEssentialExpensesFrequency}
      totalLivingExpenses={totalLivingExpenses}
      willForgoNonEssentials={willForgoNonEssentials}
    />
  );
};

export default ExpensesAUContainer;
